import script from "./courseinfoWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./courseinfoWidget.vue?vue&type=script&setup=true&lang=js"

import "./courseinfoWidget.vue?vue&type=style&index=0&id=2f127eb4&lang=scss"

const __exports__ = script;

export default __exports__